<template>
   <div class="pricing-plans-compare-table-container">
      <h2>
         {{ $t("pages.pricing.features.title") }}
      </h2>
      <div class="software-features-table">
         <div class="software-features-table-header">
         </div>
         <label class="software-features-table-features-header">{{
            $t("pages.pricing.features.table.featuresHeader")
            }}</label>
         <label class="software-features-table-free-col-header">{{ $t("pages.pricing.features.table.freeHeader")
            }}</label>
         <label class="software-features-table-std-col-header">{{ $t("pages.pricing.features.table.stdHeader")
            }}</label>
         <label class="software-features-table-plus-col-header">{{ $t("pages.pricing.features.table.plusHeader")
            }}</label>
         <div class="features-cell" style="grid-column: 1;grid-row: 2;">
            <TooltipMark>{{$t('pages.pricing.features.table.commercialDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.commercial") }}</label>
         </div>
         <img class="include" style="grid-column: 2;grid-row: 2;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 3;grid-row: 2;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 2;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 3;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 4;">
            <TooltipMark>{{$t('pages.pricing.features.table.localResourcesDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.localResources") }}</label>
         </div>
         <img class="include" style="grid-column: 2;grid-row: 4;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 3;grid-row: 4;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 4;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 5;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 6;">
            <TooltipMark>{{$t('pages.pricing.features.table.cloudDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.cloud") }}</label>
         </div>
         <img class="include" style="grid-column: 2;grid-row: 6;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 3;grid-row: 6;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 6;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 7;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 8;">
            <TooltipMark>{{$t('pages.pricing.features.table.automaticModeDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.automaticMode") }}</label>
         </div>
         <img class="include" style="grid-column: 2;grid-row: 8;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 3;grid-row: 8;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 8;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 9;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 10;">
            <TooltipMark>{{$t('pages.pricing.features.table.urlEditorDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.urlEditor") }}</label>
         </div>
         <img class="include" style="grid-column: 3;grid-row: 10;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 10;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 11;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 12;">
            <TooltipMark>{{$t('pages.pricing.features.table.studioDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.studio") }}</label>
         </div>
         <img class="include" style="grid-column: 3;grid-row: 12;" src="../../../assets/icons/include.svg" alt="+">
         <img class="include" style="grid-column: 4;grid-row: 12;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 13;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 14;">
            <TooltipMark>{{$t('pages.pricing.features.table.mapperDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.mapper") }}</label>
         </div>
         <img class="include" style="grid-column: 4;grid-row: 14;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 15;"></div>

         <div class="features-cell" style="grid-column: 1;grid-row: 16;">
            <TooltipMark>{{$t('pages.pricing.features.table.clockServerDesc')}}</TooltipMark>
            <label>{{
               $t("pages.pricing.features.table.clockServer") }}</label>
         </div>
         <img class="include" style="grid-column: 4;grid-row: 16;" src="../../../assets/icons/include.svg" alt="+">
         <div class="versions-track" style="grid-row: 17;"></div>
      </div>

   </div>
</template>

<script>
    import TooltipMark from "../../../components/TooltipMark";

    export default {
        name: "PricingPlansCompareTableSection",
        components: {TooltipMark}
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";


   .pricing-plans-compare-table-container {

      h2 {
         font-size: 1.9em;
         color: $text80;
         font-weight: 300;
         margin-right: auto;
         margin-top: 1em;
         margin-bottom: 1em;
      }

      .software-features-table {
         margin-top: 1em;
         margin-bottom: 3em;
         display: grid;
         grid-column-gap: 1em;
         grid-row-gap: 0.8em;
         align-items: stretch;
         grid-template-columns: auto auto auto auto;
         grid-template-rows: repeat(17, auto);
         color: $text80;
         font-weight: 300;

         .include {
            justify-self: center;
         }
      }

      .software-features-table-header {
         grid-column-start: 1;
         grid-column-end: 5;
         grid-row: 1;
         border-bottom: 0.1em solid $text60;
         z-index: -1;
      }

      .versions-track {
         margin-bottom: 0;
         border-bottom: 1px solid $text20;
         z-index: -1;
         grid-column-start: 1;
         grid-column-end: 5;
      }

      .software-features-table-features-header {
         grid-column: 1;
         grid-row: 1;
         color: $text100;
         margin-bottom: 0.8em;
         font-size: 1.3em;
      }

      .software-features-table-free-col-header {
         grid-column: 2;
         grid-row: 1;
         justify-self: center;
         color: $text100;
         margin-bottom: 0.8em;
         font-size: 1.3em;
      }

      .software-features-table-std-col-header {
         grid-column: 3;
         grid-row: 1;
         justify-self: center;
         color: $text100;
         margin-bottom: 0.8em;
         font-size: 1.3em;
      }

      .software-features-table-plus-col-header {
         grid-column: 4;
         grid-row: 1;
         justify-self: center;
         margin-bottom: 0.8em;
         font-size: 1.3em;
         color: $text100;
      }

      .features-cell {
         display: grid;
         grid-template-columns: auto auto;
         grid-template-rows: auto;
         justify-self: start;
         align-items: center;
         font-size: 1.2em;

         label {
            grid-column: 2;
            align-self: center;
            color: $text80;
            font-size: 0.9em;
            margin-left: 0.5rem;
         }
      }

   }
</style>